import {API_ENDPOINT_PREFIX, MERGE_TAG_MAP} from "@/constants";

export function getAbsolutePosition(element) {
    const rect = element.getBoundingClientRect()

    return {
        top: rect.top + window.scrollY,    // Add vertical scroll
        left: rect.left + window.scrollX,  // Add horizontal scroll
        bottom: rect.bottom + window.scrollY,
        right: rect.right + window.scrollX
    }
}

export function to12HrTime(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
        time = time.slice(1)
        time[5] =+ time[0] < 12 ? 'am' : 'pm'
        time[0] =+ time[0] % 12 || 12
    }

    return time.join('')
}

export function dateParts(date, longShort) {
    if (!longShort) {
        longShort = 'short'
    }
    const dateTimeFormat = new Intl.DateTimeFormat("en-US", {
        weekday: longShort,
        day: "numeric",
        month: longShort,
        timeZone: "UTC"
    });
    const parts = dateTimeFormat.formatToParts(new Date(date));
    const map = new Map(parts.map(p => Object.values(p)))

    return Object.fromEntries(map)
}

export function buildDate(string) {
    const raw = string
    const date = raw ? new Date(raw) : new Date()
    const formatted = date.toLocaleDateString(["en-US"], {timeZone: 'UTC', dateStyle: "long"})

    return {raw, date, formatted}
}

export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function scrollToElement(element, offset = -160) {
    const {top} = getAbsolutePosition(element)
    window.scrollTo({ top: top + offset, behavior: 'smooth' });
}

export function saveState(data) {
    if (!data.initialized) { // prevent unnecessary saving before initialization
        return
    }
    const allowed = ['to', 'from', 'contact', 'special', 'complete', 'requestId', 'customerId']
    data = {...data}

    Object.keys(data).forEach(key => {
        if (!allowed.includes(key)) {
            delete data[key]
        }
    })

    sessionStorage.setItem('ein-form-data', JSON.stringify(data))
}

export function loadState() {
    let data = sessionStorage.getItem("ein-form-data")
    data = JSON.parse(data)
    console.log('loading saved state', data)

    return data || null
}

export function parseMergeTags(string, dataObj) {
    return string.replaceAll(/\{([a-z\-_]+)}/g, (match, p1) => {
        const mergeKey = MERGE_TAG_MAP[p1]
        if (!mergeKey) {
            return match
        }

        const replacement = (typeof mergeKey === 'function')
        ? mergeKey(dataObj)
        : mergeKey.split(".").reduce((o, i) => o && i in o && o[i], dataObj);
        if (!replacement) {
            return match
        }

        return replacement
    })
}

export function titleCase(s) {
    return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
        .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase())
}



export function toCamelCase(str) {
    return str.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
}

export function camelCaseKeys(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj; // Return non-objects or null as is
    }

    if (Array.isArray(obj)) {
        return obj.map(camelCaseKeys); // Recursively handle arrays of objects
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
        const camelKey = toCamelCase(key);
        acc[camelKey] = camelCaseKeys(value); // Recursively handle nested objects
        return acc;
    }, {});
}

export function debounce(func, delay) {
    let timeout;

    return function(...args) {
        const context = this;
        clearTimeout(timeout); // Clear previous timeout if it exists
        timeout = setTimeout(() => {
            func.apply(context, args); // Execute the original function
        }, delay);
    };
}

/**
 * Joins an array of strings into a single comma separated string, followed by an oxford comma and conjunction
 * @param arr
 * @param conjunction
 * @param ifempty
 * @returns {*}
 */
export function oxford(arr, conjunction, ifempty) {
    let l = arr.length;
    if (!l) return ifempty;
    if (l < 2) return arr[0];
    if (l < 3) return arr.join(` ${conjunction} `);
    arr = arr.slice();
    arr[l - 1] = `${conjunction} ${arr[l - 1]}`;
    return arr.join(", ");
}

export function apiUrl(endpoint) {
    return API_ENDPOINT_PREFIX + endpoint
}

export function formatPrice(number) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(number)
}

export function dataLayerPush(event, params) {
    return new Promise((resolve, reject) => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({event: event, ...params})
        resolve(true)
    });
}

export function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export function getGaClientId() {
    const cookie = {};
    document.cookie.split(';').forEach(el => {
        const splitCookie = el.split('=')
        const key = splitCookie[0].trim()
        cookie[key] = splitCookie[1]
    })
    return cookie["_ga"]?.substring(6) || null
}

export function getGclid() {
    let params = new URL(document.location.toString()).searchParams
    return params.get('gclid')
}
